import assetPath from '/opt/actions-runner/_work/crate/crate/packages/entity-pages/entity-pages-header/src/assets/free-cover.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')